import { Box } from '@mui/material'
import { Icon as Iconify } from '@iconify/react'
import Ribbon from 'components/common/Ribbon/Ribbon'
import RibbonButton from 'components/common/Ribbon/RibbonComponents/RibbonButton'

const AlertsRibbon = ({
  selectedAlertHeader,
  selectedAlert,
  canAdd,
  onAddAlert,
  onDeleteAlert,
  canEdit,
  onEditAlert,
  changesMade,
  onSave,
  onDiscard,
  showCopyButton,
  copyButtonLabel,
  onCopyClick,
  onShowFavorites,
}) => {
  const panels = []

  if (selectedAlertHeader) {
    const items = []

    if (canAdd) {
      items.push(
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <RibbonButton
            height={55}
            iconSize={40}
            icon={<Iconify icon='fluent:add-12-filled' width={20} color='green' />}
            label='Add'
            onClick={onAddAlert}
          />
        </Box>,
      )
    }

    if (selectedAlert) {
      items.push(
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <RibbonButton
            height={55}
            iconSize={40}
            icon={<Iconify icon='material-symbols:delete-outline' width={20} color='red' />}
            label='Delete'
            onClick={onDeleteAlert}
          />
        </Box>,
      )

      if (canEdit) {
        items.push(
          <Box sx={{ display: 'flex', gap: 0.5 }}>
            <RibbonButton
              height={55}
              iconSize={40}
              icon={<Iconify icon='material-symbols:edit' width={20} color='#1976d2' />}
              label='Edit'
              onClick={onEditAlert}
            />
          </Box>,
        )
      }
    }

    panels.push({
      panelName: '',
      items,
    })
  }

  panels.push({
    panelName: '',
    items: [
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <RibbonButton
          height={50}
          iconSize={36}
          icon={<Iconify icon='material-symbols:undo' width={20} color={!changesMade ? '#8a8a8a' : '#d32f2f'} />}
          label='Discard'
          disabled={!changesMade}
          onClick={onDiscard}
        />
        <RibbonButton
          height={50}
          iconSize={36}
          icon={<Iconify icon='material-symbols:save' width={20} color={!changesMade ? '#8a8a8a' : '#1976d2'} />}
          label='Save'
          disabled={!changesMade}
          onClick={onSave}
        />
      </Box>,
    ],
  })

  if (showCopyButton) {
    panels.push({
      panelName: '',
      items: [
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <RibbonButton
            height={50}
            iconSize={36}
            icon={<Iconify icon='material-symbols:content-copy' width={20} color='#1976d2' />}
            label={copyButtonLabel}
            onClick={onCopyClick}
          />
        </Box>,
      ],
    })
  }

  panels.push({
    panelName: '',
    items: [
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <RibbonButton
          height={50}
          iconSize={36}
          icon={<Iconify icon='emojione:star' width={20} color='#1976d2' />}
          label='Favorite Wells'
          onClick={onShowFavorites}
        />
      </Box>,
    ],
  })

  return <Ribbon barHeight={90} tabs={[{ panels }]} />
}

export default AlertsRibbon
